import React from "react";
import { Box, Typography } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";
import { GOLD_PAGE_SX, GOLD_CONTENT_SX, GOLD_THEME, GoldSwoosh, GoldCrumbs } from "./goldTheme";

// ═════════════════════════════════════════════════════════════════════
//  "Under work — soon ready" page, in the same cream / gold theme as every other page.
//  Every module made from Master Settings → Modules gets its own page file (e.g. BrandKitsPage.jsx) with this as
//  its content, until the real page is written. Also the fallback when a page file is missing or empty.
// ═════════════════════════════════════════════════════════════════════
export default function ModuleComingSoon({ name = "This page", side = "admin" }) {
  return (
    <Box sx={{ ...GOLD_PAGE_SX, ...GOLD_CONTENT_SX }}>
      <GoldSwoosh id="comingSoonSwoosh" />
      <Box sx={{ position: "relative" }}>
        <GoldCrumbs crumbs={[side === "admin" ? "Admin" : "Dashboard", name]} sx={{ mb: { xs: 1.5, md: 2 } }} />
        <Box sx={{
          mt: { xs: 3, md: 6 }, mx: "auto", maxWidth: 560, textAlign: "center", p: { xs: 3, md: 5 },
          borderRadius: "20px", background: "#fffcf7", border: "1px solid #efe6d3", boxShadow: "0 12px 36px rgba(122,87,18,0.10)",
        }}>
          <Box sx={{
            width: 72, height: 72, mx: "auto", mb: 2, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center",
            background: "linear-gradient(180deg, #8c6a1c, #6f5212)", boxShadow: "0 8px 22px rgba(111,82,18,0.35)",
          }}>
            <ConstructionIcon sx={{ fontSize: 36, color: "#fff" }} />
          </Box>
          <Typography sx={{ fontSize: { xs: "1.4rem", md: "1.8rem" }, fontWeight: 800, color: GOLD_THEME.text }}>{name}</Typography>
          <Typography sx={{ mt: 1, fontSize: 15, fontWeight: 700, color: GOLD_THEME.gold }}>Under work — coming soon</Typography>
          <Typography sx={{ mt: 1.2, fontSize: 13.5, color: GOLD_THEME.muted }}>
            This page is being built and will be ready soon. The module is already saved with its route, sidebar item and permissions.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
